export default function SectionDivider() {
  return (
    <div className="w-full h-px bg-green-900 my-8 mt-3" />
  );
}